import { render } from "./mainPage.vue?vue&type=template&id=22cf17f3&ts=true"
import script from "./mainPage.vue?vue&type=script&lang=ts&config=true"
export * from "./mainPage.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__